import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

/** 弹窗软件全量列表：由排行等带入的默认筛参（重置时回到该基准） */
export interface PopupSoftwareListEmbedDefaults {
  key_word?: string
  start_time?: string
  end_time?: string
  dateRange?: [string, string]
  popup_type?: number
}

export interface PopupQueryParams {
  key_word: string // 关键词搜索
  page: number // 页码
  limit: number // 每页数量
  sort: string // 排序字段名
  asc: boolean // true-正序，false-逆序
  popup_type: number // 弹窗类型,1-右下角弹泡，2-中间弹泡，3-捆绑软件
  /** 与统计/排行一致的时间范围（秒级时间戳字符串，可选） */
  start_time?: string
  end_time?: string
}

export interface PopupItem {
  soft_id: number // 软件id
  soft_name: string // 软件名称
  intercept_count: number // 拦截次数
  popup_count: number // 弹出次数
  latest_popup_time: number // 最近弹出时间
  terminal_count: number // 弹出终端数
  popup_type?: number // 弹窗类型,1-右下角弹泡,2-中间弹泡, 3-捆绑其他软件
}

export interface DetailQueryParams {
  page: number // 页码
  limit: number // 每页数量
  sort?: string // 排序规则
  asc?: boolean // 排序,true-正序，false-倒序
  soft_id: number // 软件id
  popup_type: number // 弹窗类型,1-右下角弹泡,2-中间弹泡, 3-捆绑其他软件
}

export interface DetailItem {
  device_id: string // 终端设备id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  auto_intercept_switch: number // 自动拦截开关,1-开启,2-关闭
  ai_intercept_switch: number // AI防骚扰智能引擎开关,1-开启,2-关闭
}
export interface PopupList {
  soft_id: number // 软件id
  popup_type: number // 弹窗类型,1-右下角弹泡,2-中间弹泡,3-捆绑其他软件
}

export interface TrustOption {
  popup_list: PopupList[] // 弹窗列表
  is_trust: boolean // 是否信任,false-不信任,true-信任
}

@Injectable()
export class PopupViewService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  @ParamsClean()
  fetchPopUpList (options: PopupQueryParams & { dateRange?: [string, string] }) {
    const { dateRange: _dateRange, ...payload } = options
    return this.http
      .post<{
        total: number,
        list: PopupItem[]
      }>('/popupintercept/popup-stat', payload)
  }
  @ParamsClean()
  @InvokeThrottle()
  fetchDetailList (options: DetailQueryParams) {
    return this.http
      .post<{
        total: number,
        list: DetailItem[]
      }>('/popupintercept/popup-terminals', options)
  }

  @InvokeThrottle()
  @ParamsClean()
  trustOrder (option: TrustOption) {
    return this.http
      .post<{
        task_id: string,
        terminal_count: number
      }>('/popupintercept/popup-trust', option)
  }
}
